export const EMOJI_MAPPINGS: { [key: string]: string } = {
    // Generales
    box: '📦',
    shopping_cart: '🛒',
    shopping: '🛍️',
    receipt: '🧾',
    gift: '🎁',
    bar_chart: '📊',
    goal: '🎯',
    monthly: '📅',
    unexpected: '⚠️',
    subscription: '🔁',
    transfer: '🔄',

    // Hogar
    house: '🏠',
    rent: '🏘️',
    electricity: '💡',
    water: '🚿',
    gas: '🔥',
    internet: '🌐',
    cleaning: '🧹',
    furniture: '🛋️',

    // Tecnología
    phone: '📱',

    // Transporte
    car: '🚗',
    fuel: '⛽',
    bus: '🚌',
    taxi: '🚕',
    subway: '🚇',
    train: '🚆',
    airplane: '✈️',
    parking: '🅿️',

    // Salud
    health: '🩺',
    medicine: '💊',
    fitness: '💪🏻',

    // Comida
    dinner: '🍽️',
    coffee: '☕️',
    supermarket: '🛒',
    groceries: '🥦',
    restaurant: '🍝',
    fast_food: '🍔',
    pizza: '🍕',
    ice_cream: '🍦',
    cupcake: '🧁',
    beer: '🍺',
    medialuna: '🥐',

    // Ropa
    dress: '👗',
    shirt: '👕',

    // Mascotas
    dog: '🐶',

    // Finanzas
    bank: '🏦',
    money_bag: '💰',
    credit_card: '💳',
    salary: '💵',
    savings: '🏦',
    investment: '📈',
    debt: '📉',
    loan: '📄',
    insurance: '🛡️',
    tax: '🧮',
    pig: '🐷',

    // Trabajo / Educación
    briefcase: '💼',
    office: '🏢',
    freelance: '🧑‍💻',
    education: '🎓',
    course: '📖',
    book: '📚',

    // Ocio
    game: '🎮',
    cinema: '🎬',
    music: '🎵',
    party: '🎉',
    vacation: '🏖️',
    streaming: '📺',

    // Familia
    baby: '👶',
    heart: '❤️',

    // Herramientas
    tools: '🛠️',

    // Extra identidad (si querés usarlo en branding)
    grandma: '🧓',
    crocodile: '🐊',
};
